﻿<template>
    <div class="container">
        <div v-html="errorMessage"></div>
    </div>
</template>

<script>
    export default {
        name: 'error-toast-with-link',

        props: {
            errorMessage: ''
        }
    };
</script>